import { useState, useLayoutEffect, useEffect } from "react";
const BORDER_WIDTH = 2;
export function useTableWidth(ref) {
    const [innerWidth, setInnerWidth] = useState();
    const updateWidth = () => setInnerWidth(ref?.current?.offsetWidth);
    useLayoutEffect(() => {
        window.addEventListener("resize", updateTableWidthOnResize);
        updateTableWidthOnResize();
        return () => window.removeEventListener("resize", updateTableWidthOnResize);
    }, [ref]);
    const updateTableWidthOnResize = () => {
        const parentComponent = document.querySelector(".table-parent");
        const outerWidth = parentComponent?.getBoundingClientRect().width;
        if ((innerWidth && outerWidth && outerWidth > innerWidth) ||
            innerWidth === undefined) {
            outerWidth && setInnerWidth(outerWidth - BORDER_WIDTH);
        }
    };
    const updateTableWidth = () => {
        const handler = setTimeout(() => {
            const drawerComponent = document.querySelectorAll(".list__drawer--contents");
            let drawerWidth = 0;
            drawerComponent.forEach((drawer, i) => {
                const rowDrawerWidth = drawer.getBoundingClientRect().width;
                if (rowDrawerWidth >= drawerWidth) {
                    drawerWidth = rowDrawerWidth;
                }
            });
            setInnerWidth(drawerWidth === 0 ? undefined : drawerWidth);
        }, 1);
        return () => clearTimeout(handler);
    };
    useEffect(() => {
        if (ref)
            updateWidth();
    }, [ref]);
    return { width: innerWidth, updateTableWidth };
}
